import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface Option {
  id: string;
  name: string;
  nameEn: string;
}
interface FilterDropdownProps {
  label: string;
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}
export const FilterDropdown = ({
  label,
  options,
  value,
  onChange,
  disabled = false
}: FilterDropdownProps) => {
  const selectedOption = options.find(option => option.id === value);
  return <div className="space-y-1" data-id="element-150">
      <label className="block text-sm font-medium text-gray-700" data-id="element-151">{label}</label>
      <div className="relative" data-id="element-152">
        <select className={`block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white cursor-pointer'}`} value={value} onChange={e => onChange(e.target.value)} disabled={disabled} data-id="element-153">
          <option value="" data-id="element-154">নির্বাচন করুন (Select)</option>
          {options.map(option => <option key={option.id} value={option.id} data-id="element-155">
              {option.name} ({option.nameEn})
            </option>)}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" data-id="element-156">
          <ChevronDownIcon className="h-4 w-4" data-id="element-157" />
        </div>
      </div>
    </div>;
};